import { useState, useEffect } from "react";
import { useAuth } from "../../../provider";
import * as api from '../../../Auth/auth'
import axios from 'axios';
import PageProtected2ColTop from "../../../components/Page/PageProtected2ColTop";
import { Grid, Typography, Box, Paper, Stack, Divider, CircularProgress} from '@mui/material';
import { pool } from "../../../constants";
import OnboardingSteps from "../../../components/Steps/OnboardingSteps";
import DiaRescheduleLab from "./DiaRescheduleLab";
import * as c from '../../../constants';
import DiaAddPackages from "../AddPackages/DiaAddPackages";
import ButtonMainGoTo from "../../../components/Button/ButtonMainGoTo"
import DiaLabDetails from "./DiaLabDetails";

export default function WaitingResultsSummary() {

  const { state } = useAuth();
  const { handleLogout } = useAuth();

  const [visits, setVisits] = useState([]);
  const [labDetails, setLabDetails] = useState(null);
   const [subscription, setSubscription] = useState(null);
  const [loading, setLoading] = useState(true);

// Fetch visits
  useEffect(() => {
    const fetchVisits = async () => {
      try {
        const res = await axios.get(`${c.API_URL}/api/current-lab-visit/`);
        const data = res.data;

      // Wrap in array for consistent mapping
      const visitsArray = data ? [data] : [];
      setVisits(visitsArray);
      setLabDetails(data.laboratory); 

    } catch (err) {
      console.error("No existing lab visit found:", err);
    }
  };

  if (state?.user?.id) fetchVisits();
}, [state.user?.id]);

const handleLogoutapi = async () => {
      let response = await api.logout()
      await handleLogout(response);
  }

  // fetch stripe subscriptions
  useEffect(() => {
    axios.get(`${c.API_URL}/api/profile/stripecustomer`)
      .then((res) => {
        setSubscription(res.data);
      })
      .catch((err) => {
        console.error("Error fetching subscription:", err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  if (loading) return <CircularProgress />;
  if (!subscription) return <Typography>No data found</Typography>;

  // You can destructure the product info for cleaner access
  const { id, user, stripe_subscription_id, subscription_active, last_payment_status, product } = subscription;


return (


<PageProtected2ColTop
  
      leftsideimage={pool}
      brandtext="Preventive Health Intelligence"
      headline="Manage your Lab visit"

      content={<>

       {/* Onboarding Steps */}
            <Grid container spacing={2} sx={{mx: 4, mt: 4, p: 2, display: 'flex', justifyContent: 'center'}}>
              <Grid size={{xs: 12}} sx={{maxWidth: 600}}>
                <OnboardingSteps stepNumber={2} />
              </Grid>
            </Grid>
       
  {/* Explain status */}
  <Grid container spacing={2} sx={{ mt: 2, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
  <Grid size={{ xs: 12 }} sx={{ maxWidth: 600, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
    <Typography variant="subtitle1" textAlign="center" gutterBottom sx={{ mb: 2, fontWeight: 400 }}> 
                  Thank you for completing data. <br />
                  You are now all set for your lab visit.<br /><br />
                  The lab reception has been forwarded all required information.<br />
                  You will be asked for your 4-digit-code stated in the confirmation email we sent to you.
      </Typography>
      </Grid>
    </Grid>

 {/* Lab Visit Date and Time */}
 
   <Grid container spacing={2} sx={{ mt: 2, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
   <Grid size={{ xs: 12 }} sx={{ maxWidth: {xs:520, sm:600}, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
       {Array.isArray(visits) && visits.length > 0 ? (
         visits.map((visit) => (
           <Paper key={visit.id}  
             sx={{px: 6,py:1,b: 2,borderRadius: 2,width: "100%", minWidth: {xs:520, sm:600}, 
             display: "flex",alignItems: "center",justifyContent: "space-between", bgcolor:'grey.C300'}}>
               <Typography variant="subtitle1" fontWeight={600}> {`${visit.laboratory?.name}`} </Typography>
               <Box> <DiaLabDetails labDetails={labDetails}/> </Box>
               <Typography variant="subtitle1" fontWeight={600}>Date: {visit.visit_date}</Typography>
                 <Typography variant="subtitle1" fontWeight={600}>Time: {visit.visit_time.slice(0, 5)}</Typography>
               <Typography variant="subtitle1" fontWeight={600}>Code: {visit.check_in_code}</Typography>
           </Paper>
         ))
       ) : (
         <Typography variant="subtitle1" sx={{ color: "text.secondary", mt: 1 }}>
           No scheduled lab visits found.
         </Typography>
       )}    
     </Grid>
    </Grid>
 
        
{/* Reschedule app */} 
  <Grid container spacing={2} sx={{ mt: 2, justifyContent: 'center', alignItems: 'center', }}>
  <Grid size={{ xs: 12 }} sx={{ maxWidth: 600, display: 'flex', justifyContent: 'center', alignItems: 'center'  }}>
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="center">
           <Typography variant="subtitle1" sx={{ fontWeight: 600 }}> 
                  You want to reschedule your lab visit?
          </Typography> 
          <DiaRescheduleLab  /> 
          </Stack>
      </Grid>
   </Grid>

{/* Product/Subscription Info */}
 <Grid container sx={{ mt: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
  <Grid size={{ xs: 12 }} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mt: 1 }}>
    <Box sx={{ maxWidth: 600, width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
 
  {product ? (
    <Paper elevation={3}
      sx={{maxWidth: {xs:520, sm:600}, width: '100%', mx: "auto", mt: 2,p: 3,borderRadius: 3,bgcolor: "grey.C300",}}>
      
      <Typography variant="subtitle1" fontWeight={600} textAlign="center" sx={{mb:2}}>
        Your Membership
      </Typography>
      <Stack spacing={1.5}>
        <Box sx={{display: "flex",justifyContent: "space-between",alignItems: "center",bgcolor: "grey.C200",borderRadius: 2,px: 2,py: 1,boxShadow: 1,}}>
            <Typography variant="subtitle2" fontWeight={500}>
              {product.name}
            </Typography>
            <Typography variant="subtitle2" fontWeight={500} >
              per test &nbsp;&nbsp; €{product.price_eur}
            </Typography>
        </Box>
      </Stack>

        {last_payment_status == "succeeded" ? (
            <Typography variant="body2" textAlign="right" sx={{mt:1, fontWeight: 500 }}>
              ✅ Payment confirmed
            </Typography>
          ) : (
            <Typography variant="body2" textAlign="right" sx={{ color: "error.main", fontWeight: 500 }}>
              ❌ Not paid
            </Typography>
          )}
           <Divider sx={{ my: 3 }} />
          
          <Box sx={{my:2, px:2}}> 
            <Typography variant="subtitle1" textAlign="center" sx={{ mb: 2, fontWeight: 600 }}> 
              Easily add one or more tests to your upcoming visit:
            </Typography>
            </Box>
             <Box sx={{display:'flex',justifyContent:'center'}}> <DiaAddPackages /></Box>
            <Box sx={{display: "flex",justifyContent: "space-between",alignItems: "center",bgcolor: "grey.C200",borderRadius: 2,mt:2,px: 2,py: 2,boxShadow: 1,}}>
         
            <Typography variant="subtitle2" textAlign="center" gutterBottom sx={{ mb: 2, fontWeight: 400 }}> 
                    Check out attractive packages:<br /> <br />Hormones (female / male), Vitamins & Nutrients, Omega Fatty Acids, Bones Health,
                    Thyroid Cancer Prevention, Artherosclerosis Prevention, Fertily Check & Ovarian Reserve, 
                    Colon Cancer Prevention      
            </Typography>
            </Box>  
        </Paper>
          ) : (
        <Typography variant="subtitle1" sx={{ color: "text.secondary", mt: 2 }}>
          No Membership found for this visit.
        </Typography>
      )}
    </Box>
  </Grid>
</Grid>

{/* logout / relogin logic */}
  <Grid container spacing={2} sx={{ mt: 6, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
  <Grid size={{ xs: 12 }} sx={{ maxWidth: 600, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
    <Typography variant="subtitle1" textAlign="center" gutterBottom sx={{ mb: 2, fontWeight: 400 }}> 
                
                No add-on tests this time? Maybe next time.<br /><br />
                You will be notified by email <br />when results & personalized recommendations are ready. <br />
          </Typography>
        </Grid>
     </Grid>
  <Grid container spacing={2} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
  <Grid size={{ xs: 12 }} sx={{ maxWidth: 600, display: 'flex', justifyContent: 'center', alignItems: 'center' }}></Grid>
        <Grid size={12} sx={{mt:2, display:'flex', justifyContent:'center'}}> 
            <ButtonMainGoTo buttontext="LOGOUT" to="/Login" onClick={handleLogoutapi}/>
       </Grid> 
    </Grid>

  </>}
/>
)}


